// extracted by mini-css-extract-plugin
export default {"heading-5":"SJi6K a8cCT","heading5":"SJi6K a8cCT","background-color":"#F2F2F2","backgroundColor":"#F2F2F2","heading":"WP91J SJi6K a8cCT","productSizes":"EfL8n","size":"TsxQO"};